import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, map } from "rxjs";
import {
  ICatalogItem,
  CatalogGroup,
  IAcademy,
  ISchool,
  IFactor,
  IGroups,
  ICompetence,
  CatalogItemPossibilities,
  ICalendarCatalog,
  ICourseType,
  IRegion,
  ISede,
  IArea,
  ISubArea,
  IOrganization,
  ICountry,
  IEventPlanName,
  IRole,
  EventPlansFilters,
} from "../interfaces/catalog.interface";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { environment } from "src/environments/environment";
import { calendarCatalogs } from "../constants/catalog.constants";

@Injectable({
  providedIn: "root",
})
export class CatalogService {
  [x: string]: any;
  private catalogsUrl = `${environment.apiUrlCap}/api/catalogs`;
  // Academy list
  private academyListSubject: BehaviorSubject<IAcademy[]> = new BehaviorSubject<
    IAcademy[]
  >([]);
  public academyList: Observable<IAcademy[]> =
    this.academyListSubject.asObservable();

  // School list
  private SchoolListSubject: BehaviorSubject<ISchool[]> = new BehaviorSubject<
    ISchool[]
  >([]);
  public schoolList: Observable<ISchool[]> =
    this.SchoolListSubject.asObservable();

  // Factor list
  private FactorListSubject: BehaviorSubject<IFactor[]> = new BehaviorSubject<
    IFactor[]
  >([]);
  public factorList: Observable<IFactor[]> =
    this.FactorListSubject.asObservable();

  // Group list
  private GroupListSubject: BehaviorSubject<IGroups[]> = new BehaviorSubject<
    IGroups[]
  >([]);
  public groupList: Observable<IGroups[]> =
    this.GroupListSubject.asObservable();

  // competencies list
  private competenceListSubject: BehaviorSubject<ICompetence[]> =
    new BehaviorSubject<ICompetence[]>([]);
  public competenceList: Observable<ICompetence[]> =
    this.competenceListSubject.asObservable();

  // course type list
  private courseTypeListSubject: BehaviorSubject<ICourseType[]> =
    new BehaviorSubject<ICourseType[]>([]);
  public courseTypeList: Observable<ICourseType[]> =
    this.courseTypeListSubject.asObservable();

  // Capacitation Type
  private capacitationType: BehaviorSubject<CatalogGroup> =
    new BehaviorSubject<any>(null);
  public capacitationTypeS: Observable<CatalogGroup> =
    this.capacitationType.asObservable();

  // region list
  private regionListSubject: BehaviorSubject<IRegion[]> = new BehaviorSubject<
    IRegion[]
  >([]);
  public regionList: Observable<IRegion[]> =
    this.regionListSubject.asObservable();

  // role list
  private roleListSubject: BehaviorSubject<IRole[]> = new BehaviorSubject<
    IRole[]
  >([]);
  public roleList: Observable<IRole[]> = this.roleListSubject.asObservable();

  // sede list
  private sedeListSubject: BehaviorSubject<ISede[]> = new BehaviorSubject<
    ISede[]
  >([]);
  public sedeList: Observable<ISede[]> = this.sedeListSubject.asObservable();

  // area list
  private areaListSubject: BehaviorSubject<IArea[]> = new BehaviorSubject<
    IArea[]
  >([]);
  public areaList: Observable<IArea[]> = this.areaListSubject.asObservable();

  // subArea list
  private subAreaListSubject: BehaviorSubject<ISubArea[]> = new BehaviorSubject<
    ISubArea[]
  >([]);
  public subAreaList: Observable<ISubArea[]> =
    this.subAreaListSubject.asObservable();

  // organization list
  private organizationListSubject: BehaviorSubject<IOrganization[]> =
    new BehaviorSubject<IOrganization[]>([]);
  public organizationList: Observable<IOrganization[]> =
    this.organizationListSubject.asObservable();

  // country list
  private countryListSubject: BehaviorSubject<ICountry[]> = new BehaviorSubject<
    ICountry[]
  >([]);
  public countryList: Observable<ICountry[]> =
    this.countryListSubject.asObservable();

  // calendar catalog item list
  private calendarCatalogListSubject: BehaviorSubject<ICalendarCatalog[]> =
    new BehaviorSubject<ICalendarCatalog[]>([]);
  public calendarCatalogList: Observable<ICalendarCatalog[]> =
    this.calendarCatalogListSubject.asObservable();
  // Years catalog item list
  private yearsListSubject: BehaviorSubject<ICalendarCatalog[]> =
    new BehaviorSubject<ICalendarCatalog[]>([]);
  public yearCatalogList: Observable<ICalendarCatalog[]> =
    this.yearsListSubject.asObservable();
  // justification catalog item list
  private justificationListSubject: BehaviorSubject<ICatalogItem[]> =
    new BehaviorSubject<ICatalogItem[]>([]);
  public justificationCatalogList: Observable<ICatalogItem[]> =
    this.justificationListSubject.asObservable();

  // selected catalog
  private selectedCatalogSubject: BehaviorSubject<CatalogGroup> =
    new BehaviorSubject<any>(null);
  public selectedCatalog$: Observable<CatalogGroup> =
    this.selectedCatalogSubject.asObservable();

  constructor(private http: HttpClient) {}

  private handleData(
    catalogType: CatalogGroup,
    responseData: ICatalogItem[],
    getAllItems: boolean = false
  ) {
    if (!getAllItems) {
      responseData = responseData.filter(
        item => item.activo === undefined || item.activo
      );
    }
    let data: any;
    if (calendarCatalogs.includes(catalogType)) {
      data = responseData as ICalendarCatalog[];
      this.calendarCatalogListSubject.next(data);
      return;
    }
    switch (catalogType) {
      case "academies":
        data = responseData as IAcademy[];
        this.academyListSubject.next(data);
        break;
      case "schools":
        data = responseData as ISchool[];
        this.SchoolListSubject.next(data);
        break;
      case "factor":
        data = responseData as IFactor[];
        this.FactorListSubject.next(data);
        break;
      case "grupo":
        data = responseData as IGroups[];
        this.GroupListSubject.next(data);
        break;
      case "competencias":
        data = responseData as ICompetence[];
        this.competenceListSubject.next(data);
        break;
      case "tipoCurso":
        data = responseData as ICourseType[];
        this.courseTypeListSubject.next(data);
        break;
      case "region":
        data = responseData as IRegion[];
        this.regionListSubject.next(data);
        break;
      case "roles":
        data = responseData as IRole[];
        this.roleListSubject.next(data);
        break;
      case "sede":
        data = responseData as ISede[];
        this.sedeListSubject.next(data);
        break;
      case "area":
        data = responseData as IArea[];
        this.areaListSubject.next(data);
        break;
      case "subArea":
        data = responseData as ISubArea[];
        this.subAreaListSubject.next(data);
        break;
      case "organization":
        data = responseData as IOrganization[];
        this.organizationListSubject.next(data);
        break;
      case "country":
        data = responseData as ICountry[];
        this.countryListSubject.next(data);
        break;
      case "year":
        data = responseData;
        this.yearsListSubject.next(data);
        break;
      case "justification":
        data = responseData;
        this.justificationListSubject.next(data);
        break;
      default:
        throw new Error("Not Implemented");
    }
  }

  private getRequestParam(catalogType: CatalogGroup): string {
    return calendarCatalogs.includes(catalogType)
      ? `calendar/${catalogType}`
      : catalogType;
  }

  getCatalogList(
    catalogType: CatalogGroup,
    getAllItems: boolean = false
  ): Promise<boolean> {
    const reqParam = this.getRequestParam(catalogType);
    return new Promise<boolean>((resolve, reject) => {
      this.http
        .get<ResponseDataInterfaces<ICatalogItem[]>>(
          `${this.catalogsUrl}/${reqParam}`
        )
        .subscribe({
          next: ({ data }) => {
            const catalogItems = data;
            this.handleData(catalogType, catalogItems, getAllItems);
            resolve(true);
          },
          error: error => {
            this.handleData(catalogType, []);
            reject(error);
          },
        });
    });
  }

  selectCatalogGroup(
    catalogType: CatalogGroup,
    getAllItems: boolean = false
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.selectedCatalogSubject.next(catalogType);
      this.getCatalogList(catalogType, getAllItems)
        .then(() => resolve(true))
        .catch(error => reject(error));
    });
  }
  getSchoolsByAcademy(academyId: string) {
    const catalogType = "schools";
    this.http
      .get<ResponseDataInterfaces<ISchool[]>>(
        `${this.catalogsUrl}/${catalogType}/${academyId}`
      )
      .subscribe({
        next: response => {
          const dataFixed = response.data;
          this.handleData(catalogType, dataFixed);
        },
        error: error => {
          this.handleData(catalogType, []);
        },
      });
  }
  getGroupsByFactor(factorId: string) {
    const catalogType = "grupo";
    this.http
      .get<ResponseDataInterfaces<IGroups[]>>(
        `${this.catalogsUrl}/${catalogType}/${factorId}`
      )
      .subscribe({
        next: response => {
          const dataFixed = response.data;
          this.handleData(catalogType, dataFixed);
        },
        error: error => {
          this.handleData(catalogType, []);
        },
      });
  }
  getCompetenceByGroups(groupId: string) {
    const catalogType = "competencias";
    this.http
      .get<ResponseDataInterfaces<ICompetence[]>>(
        `${this.catalogsUrl}/${catalogType}/${groupId}`
      )
      .subscribe({
        next: response => {
          const dataFixed = response.data;
          this.handleData(catalogType, dataFixed);
        },
        error: error => {
          this.handleData(catalogType, []);
        },
      });
  }
  getSedeByRegion(region: string) {
    const catalogType = "sede";
    this.http
      .get<ResponseDataInterfaces<ISede[]>>(
        `${this.catalogsUrl}/${catalogType}/${region}`
      )
      .subscribe({
        next: response => {
          const dataFixed = response.data;
          this.handleData(catalogType, dataFixed);
        },
        error: error => {
          this.handleData(catalogType, []);
        },
      });
  }
  getSubAreaByArea(area: string) {
    const catalogType = "subArea";
    this.http
      .get<ResponseDataInterfaces<ISubArea[]>>(
        `${this.catalogsUrl}/${catalogType}/${area}`
      )
      .subscribe({
        next: response => {
          const dataFixed = response.data;
          this.handleData(catalogType, dataFixed);
        },
        error: error => {
          this.handleData(catalogType, []);
        },
      });
  }
  postNewCatalogItem(
    catalogItem: CatalogItemPossibilities,
    catalogType: CatalogGroup
  ) {
    const reqParam = this.getRequestParam(catalogType);
    return this.http
      .post<ResponseDataInterfaces<CatalogItemPossibilities>>(
        `${this.catalogsUrl}/${reqParam}`,
        catalogItem
      )
      .pipe(map(({ data }) => data));
  }

  // Functionality removed, commented in case it is needed again
  // deleteCatalogItem(catalogType: CatalogGroup, id: number) {
  //   const reqParam = this.getRequestParam(catalogType);
  //   return this.http
  //     .delete<ResponseDataInterfaces<boolean>>(
  //       `${this.catalogsUrl}/${reqParam}/${id}`
  //     )
  //     .pipe(map(({ data }) => data));
  // }
  // deleteCalendarCatalogItem(
  //   catalogType: CatalogGroup,
  //   calendarCatalogItem: ICalendarCatalog
  // ) {
  //   const reqParam = this.getRequestParam(catalogType);
  //   return this.http
  //     .delete<ResponseDataInterfaces<ICalendarCatalog>>(
  //       `${this.catalogsUrl}/${reqParam}/`,
  //       { body: calendarCatalogItem }
  //     )
  //     .pipe(map(({ data }) => data));
  // }
  EditCatalogItem(
    catalogItem: CatalogItemPossibilities,
    catalogType: CatalogGroup
  ) {
    const reqParam = this.getRequestParam(catalogType);
    return this.http
      .put<ResponseDataInterfaces<ICatalogItem>>(
        `${this.catalogsUrl}/${reqParam}`,
        catalogItem
      )
      .pipe(map(({ data }) => data));
  }
  private buildEventPlansParams(filters?: EventPlansFilters): HttpParams {
    let params = new HttpParams();

    if (!filters) {
      return params;
    }

    if (filters.monthNumber != null) {
      params = params.set("monthNumber", filters.monthNumber);
    }

    if (filters.yearNumber != null) {
      params = params.set("yearNumber", filters.yearNumber);
    }

    return params;
  }
  getEventPlansIdByUserId(
    userId: number,
    filters?: EventPlansFilters
  ): Observable<IEventPlanName[]> {
    const url = `${this.catalogsUrl}/calendar/Evento/${userId}`;

    const params = this.buildEventPlansParams(filters);

    return this.http
      .get<ResponseDataInterfaces<IEventPlanName[]>>(url, { params })
      .pipe(map(r => r.data));
  }

  findNameOnCatalogListById(catalogList: ICatalogItem[], id: number): string {
    return catalogList.find(Item => Item.id === id)?.nombre ?? "Dato faltante";
  }
}
